export default __webpack_public_path__ + "static/media/error.a7447d8a.jpg";